/** 一站式旅游服务详情页：首图 + 右侧四图（与 assets/guide 目录对应） */
export const GUIDE_PAGE_ASSETS = {
  bcfw: {
    hero: require("@/assets/guide/bcfw/bg.jpg"),
    gallery: [
      require("@/assets/guide/bcfw/description1.jpg"),
      require("@/assets/guide/bcfw/description2.jpg"),
      require("@/assets/guide/bcfw/description3.jpg"),
      require("@/assets/guide/bcfw/description4.jpg"),
    ],
  },
  cjly: {
    hero: require("@/assets/guide/jdyd/bg.jpg"),
    gallery: [
      require("@/assets/guide/jdyd/description1.jpg"),
      require("@/assets/guide/jdyd/description2.jpg"),
      require("@/assets/guide/jdyd/description3.jpg"),
      require("@/assets/guide/jdyd/description4.jpg"),
    ],
  },
  qzbl: {
    hero: require("@/assets/guide/qzbl/bg.jpg"),
    gallery: [
      require("@/assets/guide/qzbl/description1.jpg"),
      require("@/assets/guide/qzbl/description2.jpg"),
      require("@/assets/guide/qzbl/description3.jpg"),
      require("@/assets/guide/qzbl/description4.jpg"),
    ],
  },
  gnly: {
    hero: require("@/assets/guide/mpyd/bg.jpg"),
    gallery: [
      require("@/assets/guide/mpyd/description1.jpg"),
      require("@/assets/guide/mpyd/description2.jpg"),
      require("@/assets/guide/mpyd/description3.jpg"),
      require("@/assets/guide/mpyd/description4.jpg"),
    ],
  },
  qydz: {
    hero: require("@/assets/guide/zgwd/bg.jpg"),
    gallery: [
      require("@/assets/guide/zgwd/description1.jpg"),
      require("@/assets/guide/zgwd/description2.jpg"),
      require("@/assets/guide/zgwd/description3.jpg"),
      require("@/assets/guide/zgwd/description4.jpg"),
    ],
  },
  srdz: {
    hero: require("@/assets/guide/ztly/bg.jpg"),
    gallery: [
      require("@/assets/guide/ztly/description1.jpg"),
      require("@/assets/guide/ztly/description2.jpg"),
      require("@/assets/guide/ztly/description3.jpg"),
      require("@/assets/guide/ztly/description4.jpg"),
    ],
  },
};

/** 首页一站式服务卡片缩略图 */
export const GUIDE_CARD_IMGS = [
  require("@/assets/guide/bcfw/bg.jpg"),
  require("@/assets/guide/jdyd/bg.jpg"),
  require("@/assets/guide/qzbl/bg.jpg"),
  require("@/assets/guide/mpyd/bg.jpg"),
  require("@/assets/guide/zgwd/bg.jpg"),
  require("@/assets/guide/ztly/bg.jpg"),
];
